export default __webpack_public_path__ + "static/media/hu.b4afa8ba.svg";